// eslint-disable-next-line import/export
export type * from "./nestjs-common";

export const _ = "";
